import { FULL_ACCESS_ACTION_NAMES } from 'widget/ui-selectors/video-access';


export default function getCallbackFromProps(props, fullAccessAction) {
  if (fullAccessAction === FULL_ACCESS_ACTION_NAMES.SUBSCRIBE) {
    return props.onSubscriptionRequest;
  } else if (fullAccessAction) {
    return props.onPurchaseRequest;
  }

  return _.noop;
}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/components/player-overlay/ui-selectors/video-overlay/paid-access/callback.js